/**
 * src/components/Sidebar.js
 */

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function IconDashboard() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="1" y="1" width="6" height="6" rx="1.5"/>
      <rect x="9" y="1" width="6" height="6" rx="1.5"/>
      <rect x="1" y="9" width="6" height="6" rx="1.5"/>
      <rect x="9" y="9" width="6" height="6" rx="1.5"/>
    </svg>
  );
}

function IconConfig() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="8" cy="8" r="2.5"/>
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.1 3.1l1.4 1.4M11.5 11.5l1.4 1.4M3.1 12.9l1.4-1.4M11.5 4.5l1.4-1.4"/>
    </svg>
  );
}

function IconHistory() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="8" cy="8" r="6"/>
      <path d="M8 5v3.5l2 1.5"/>
    </svg>
  );
}

function IconUsers() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="6" cy="5" r="2.5"/>
      <path d="M1 13c0-2.8 2.2-5 5-5s5 2.2 5 5"/>
      <path d="M11 7c1.4 0 3 .9 3 3" strokeLinecap="round"/>
      <circle cx="11.5" cy="4" r="2"/>
    </svg>
  );
}

function IconKey() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="5" cy="6.5" r="3"/>
      <path d="M7.5 8.5l5.5 5.5M11 12l2-2"/>
    </svg>
  );
}

function IconLogout() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3"/>
      <path d="M11 11l3-3-3-3M14 8H6"/>
    </svg>
  );
}

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-dot" />
        <div>
          <div className="sidebar-logo-text">Process Tracker</div>
          <div className="sidebar-logo-sub">{user?.accountName}</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section">Overview</div>
        <NavLink
          to="/dashboard"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <IconDashboard /> Dashboard
        </NavLink>

        <div className="sidebar-section">Configuration</div>
        <NavLink
          to="/config"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <IconConfig /> Config Editor
        </NavLink>
        <NavLink
          to="/config/history"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <IconHistory /> Version History
        </NavLink>

        {user?.role === 'admin' && (
          <>
            <div className="sidebar-section">Account</div>
            <NavLink
              to="/users"
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              <IconUsers /> Users
            </NavLink>
            <NavLink
              to="/api-keys"
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
            >
              <IconKey /> API Keys
            </NavLink>
          </>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <strong>{user?.email}</strong>
          {user?.role}
        </div>
        <button className="sidebar-link btn-ghost w-full" onClick={handleLogout}
          style={{ background: 'none', border: 'none', textAlign: 'left', width: '100%', padding: '6px 0' }}>
          <IconLogout /> Sign out
        </button>
      </div>
    </aside>
  );
}
